module.exports = __webpack_public_path__ + "img/user-group.d617882e.png";